<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('disclaimer.Header') }}</h2>
                <h3>{{ $t('disclaimer.LiabilityForContent') }}</h3>
                <br />
                {{ $t('disclaimer.LiabilityForContentText') }}
                <h3>{{ $t('disclaimer.LiabilityForLinks') }}</h3>
                <br />
                {{ $t('disclaimer.LiabilityForLinksText') }}
                <h3>{{ $t('disclaimer.Copyright') }}</h3>
                <br />
                {{ $t('disclaimer.CopyrightText') }}
                <h3>{{ $t('disclaimer.Privacy') }}</h3>
                <br />
                {{ $t('disclaimer.PrivacyText') }}
                <br />
                {{ $t('disclaimer.Source') }}
                <br />
                <br />
                <br />
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import { EventBus } from '@/classes/eventBus.js';

    export default {
        props: {
            linkItem: String,
            myText: String
        },
        data: function () {
            return {
                theImage: '',
            }
        },
        computed: {
        },
        mounted() {
           EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
        },
        methods: {
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>